import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export type StatusValue = 'active' | 'include_inactive' | 'include_deleted';

export interface StatusFilterProps {
  value: StatusValue;
  onChange: (v: StatusValue) => void;
}

const LABEL: Record<StatusValue, string> = {
  active: 'Active only',
  include_inactive: 'Include inactive',
  include_deleted: 'Include deleted (Recycle Bin)',
};

export function StatusFilter({ value, onChange }: StatusFilterProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1 rounded border border-slate-200 bg-white px-2.5 py-1 text-xs text-slate-700 shadow-sm hover:bg-slate-50"
      >
        <span>{LABEL[value]}</span>
        <ChevronDown className="h-3 w-3" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute left-0 z-20 mt-1 w-56 rounded-md border border-slate-200 bg-white py-1 shadow-lg">
            {(Object.keys(LABEL) as StatusValue[]).map((k) => (
              <button
                key={k}
                type="button"
                onClick={() => { onChange(k); setOpen(false); }}
                className="block w-full px-3 py-1.5 text-left text-xs hover:bg-slate-50"
              >
                {LABEL[k]}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
